<template>
  <div class="wrap">
    <div class="card-wrap">
      <div class="banner">
        <img :alt="name" :src="'/static/img/contactback.webp'" width="100%"/>
      </div>
      <a-card hoverable class="product-card">
        <div flex style="align-items: center">
          <img :alt="name" :src="'/static/img/logo.png'" width="50px"/>
          <span class="title">{{name}}</span>
        </div>
        <div class="content">
          <div flex flex-column class="contact-wrap">
            <h2>销售联系方式</h2>
            <div flex flex-column>
              <p>电话：{{contact.sale.telephone}}</p>
              <p>手机：{{contact.sale.phone}}</p>
              <p>联系人：{{contact.sale.contact}}</p>
              <p>QQ：{{contact.sale.qq}}</p>
              <p>微信：{{contact.sale.wechat}}</p>
              <p>邮箱：{{contact.sale.email}}</p>
            </div>
          </div>
          <!-- <img src="/static/img/card.jpg" class="c-card" alt="名片"> -->
        </div>
        <div flex flex-column class="contact-wrap">
          <h2>公司地址</h2>
          <iframe src="/static/addressmap.html" class="address-img" frameborder="0"></iframe>
          <div flex flex-column>
            <p v-for="(e, i) in contact.address" :key="i">
              {{e.name}}：{{e.address}}
            </p>
          </div>
        </div>          
      </a-card>
    </div>
  </div>
</template>

<script>
import appConf from "@/config/config";
const { name, icp, footerDesc, contact } = appConf;

export default {
  name: "Index",
  data() {
    return {
      name,
      icp,
      footerDesc,
      contact
    };
  },
  methods: {   
  }
};
</script>
<style lang="css" scoped>
.title {
  font-size: 36px;
  margin-left: 2px;
}
.card-wrap {
  width: 100%;
  margin-bottom: 80px;
  display: flex;  
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}
.banner {
  width: 100%;
  max-height: 450px;
}
.card-wrap .product-card {
  min-width: 300px;
  max-width: 1300px;
  width: 80%;
  margin: 20px;
}
.address-text {
  margin: 20px 0;
}
.address-img {
  width: 100%;
  height: 410px;
  overflow: hidden;
  margin: 0 auto;
}
.content {
  padding: 20px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
}
.c-card {
  width: 50%;
  border: 2px solid rgb(217, 217, 217);
}
.contact-wrap {
  margin: 20px;
}
.contact-wrap p {
  font-weight: bold;
}
*[flex] {
  display: flex;
}
*[flex-column] {
  flex-direction: column;
}
@media screen and (max-width: 666px) {
  .title {
    font-size: 26px;
  }
  .banner {
    max-height: 250px;
  }
  .card-wrap {
    padding: 0;
    margin: 0 auto;
  }
  .card-wrap .product-card {
    width: 100%;
    margin: 0px;
  }
  .address-img {
    height: 320px;
  }
  .c-card {
    width: 100%;
  }
}
</style>
